import { useTranslation } from "next-i18next";
import * as NWONLogoLottie from "../../../../../public/lottie-jsons/nwon-logo.json";
import { CompanyFact } from "../../../../interfaces/team";

export const useCompanyFactNameMeaning = (): CompanyFact => {
  const { t } = useTranslation<"companyFacts">("companyFacts");

  return {
    title: t("nameMeaning.title"),
    description: t("nameMeaning.description"),
    lottieAnimation: NWONLogoLottie,
  };
};
